import { render, staticRenderFns } from "./ReservationReceiptRegistration.vue?vue&type=template&id=75508ba8&scoped=true&"
import script from "./ReservationReceiptRegistration.vue?vue&type=script&lang=js&"
export * from "./ReservationReceiptRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ReservationReceiptRegistration.vue?vue&type=style&index=0&id=75508ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75508ba8",
  null
  
)

export default component.exports